export enum testSummaryTypes {
    FETCH_TEST_SUMMARY_REQUEST = 'FETCH_TEST_SUMMARY_REQUEST',
    SET_TEST_SUMMARY = 'SET_TEST_SUMMARY',
}
